import { useEffect, useState } from "react";
import { Reveal } from "../components/Reveal";
import { fetchTeam } from "../lib/api";

const Team = () => {
  const [team, setTeam] = useState([]);
  useEffect(() => { fetchTeam().then(setTeam).catch(() => {}); }, []);

  return (
    <div data-testid="team-page">
      <section className="border-b border-[var(--rule)] py-20 lg:py-32">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <Reveal className="lg:col-span-3">
            <p className="text-[11px] tracking-[0.32em] uppercase text-neutral-500">— Vol. 03 · Practice</p>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-9">
            <h1 className="font-serif text-5xl sm:text-7xl lg:text-[8.5vw] font-light tracking-tighter leading-[0.92]">
              Three partners. <span className="italic">No bench.</span>
            </h1>
            <p className="font-serif text-xl lg:text-2xl text-neutral-700 mt-10 max-w-3xl leading-snug">
              The people on this page are the people who will work on your matter. There is no
              second tier, and no engagement is delegated below the names you meet.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="py-20 lg:py-28">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <div className="border-t border-neutral-900">
            {team.map((m, i) => (
              <Reveal key={m.id} delay={i * 0.08}>
                <article
                  data-testid={`team-member-${i}`}
                  className="border-b border-neutral-900 py-14 lg:py-20"
                >
                  <div className="grid grid-cols-12 gap-6 lg:gap-10 items-baseline mb-10">
                    <span className="col-span-2 lg:col-span-1 marker text-3xl lg:text-5xl text-neutral-400">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div className="col-span-10 lg:col-span-11">
                      <p className="text-[10px] tracking-[0.28em] uppercase text-neutral-500 mb-3">
                        {m.title}
                      </p>
                      <h2 className="font-serif text-5xl sm:text-7xl lg:text-[7vw] font-light tracking-tighter leading-[0.95]">
                        {m.name.split(" ").slice(0, -1).join(" ")}{" "}
                        <span className="italic">{m.name.split(" ").slice(-1)}</span>
                      </h2>
                      <p className="font-serif text-lg lg:text-2xl text-neutral-600 italic mt-4 max-w-3xl">
                        {m.specialization}
                      </p>
                    </div>
                  </div>

                  <div className="grid grid-cols-12 gap-6 lg:gap-10 border-t border-[var(--rule)] pt-8">
                    <div className="hidden lg:block lg:col-span-1" />
                    <div className="col-span-12 lg:col-span-7">
                      <p className="text-base text-neutral-800 leading-[1.85] whitespace-pre-line">
                        {m.bio}
                      </p>
                    </div>
                    <aside className="col-span-12 lg:col-span-3 lg:col-start-10">
                      <div className="border-t border-[var(--rule)] pt-4">
                        <p className="text-[10px] tracking-[0.28em] uppercase text-neutral-500">Discipline</p>
                        <p className="text-sm text-neutral-800 mt-2 leading-relaxed">{m.specialization}</p>
                      </div>
                      <div className="border-t border-[var(--rule)] pt-4 mt-6">
                        <p className="text-[10px] tracking-[0.28em] uppercase text-neutral-500">Role</p>
                        <p className="text-sm text-neutral-800 mt-2">{m.title}</p>
                      </div>
                    </aside>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Team;
